import t from '../common/localization'

export default {
  'remarks': {
    name: t('reportRemarks'),
    type: 'string',
  },
  'setTimezone': {
    name: t('commandSetTimezone'),
    type: 'string',
  },
  'apnCmd': {
    name: t('apnCmd'),
    type: 'string',
  },
  'serverCmd': {
    name: t('serverCmd'),
    type: 'string',
  },
  'paramCmd': {
    name: t('paramCmd'),
    type: 'string',
  },
  'statusCmd': {
    name: t('statusCmd'),
    type: 'string',
  },
  'engineResume': {
    name: t('commandEngineResume'),
    type: 'string',
  },
  'engineStop': {
    name: t('commandEngineStop'),
    type: 'string',
  },
 'rebootDevice': {
    name: t('commandRebootDevice'),
    type: 'string',
  },
 'outputControl': {
    name: t('commandOutputControl'),
    type: 'string',
  },
  'alarmVibration': {
    name: t('alarmVibration'),
    type: 'string',
  },
  'geoLocCmd': {
    name: t('geoLocCmd'),
    type: 'string',
  },
    'report.ignoreOdometer': {
      name: t('attributeReportIgnoreOdometer'),
      type: 'boolean',
    },
    'processing.copyAttributes': {
      name: t('attributeProcessingCopyAttributes'),
      type: 'string',
    },
    'processing.copyAttributesSecondary': {
      name: t('attributeProcessingCopyAttributesSecondary'),
      type: 'string',
    },
    'time.override.deviceTime': {
      name: t('attributeTimeOverrideDeviceTime'),
      type: 'boolean',
    },
    'time.override.serverTime': {
      name: t('attributeTimeOverrideServerTime'),
      type: 'boolean',
    },
    'filter.distance': {
      name: t('attributeFilterDistance'),
      type: 'boolean',
    },
    'filter.invalid': {
      name: t('attributeFilterInvalid'),
      type: 'boolean',
    },
    'filter.old': {
      name: t('attributeFilterOld'),
      type: 'boolean',
    },
    'filter.maxSpeed': {
      name: t('attributeFilterMaxSpeed'),
      type: 'number',
    },
    'coordinates.minError.ignitionOff': {
      name: t('attributeCoordinatesMinErrorIgnitionOff'),
      type: 'number',
    },
    'coordinates.maxError': {
      name: t('attributeCoordinatesMaxError'),
      type: 'number',
    },
    'useUnnecessaryAlarms': {
      name: t('attributeUseUnnecessaryAlarms'),
      type: 'string',
    },
    'report.useDistanceForMileageFuel': {
      name: t('attributeUseDistanceForMileageFuel'),
      type: 'boolean',
    },
'extraCmd1': {
      name: t('extraCmd1'),
      type: 'string',
    },
'extraCmd2': {
      name: t('extraCmd2'),
      type: 'string',
    },
'extraCmd3': {
      name: t('extraCmd3'),
      type: 'string',
    },
'extraCmd4': {
      name: t('extraCmd4'),
      type: 'string',
    },
'extraCmd5': {
      name: t('extraCmd5'),
      type: 'string',
    },
    'setUpCmd1': {
        name: t('setUpCmd1'),
        type: 'string',
      },
      'setUpCmd2': {
        name: t('setUpCmd2'),
        type: 'string',
      },
      'setUpCmd3': {
        name: t('setUpCmd3'),
        type: 'string',
      },
      'setUpCmd4': {
        name: t('setUpCmd4'),
        type: 'string',
      },
      'setUpCmd5': {
        name: t('setUpCmd5'),
        type: 'string',
      }
};
